import { IntegrationSchedule } from "../../types/types";
import { Action } from "../types";
import {INTEGRATION_ACTION_TYPES} from "../actions/integrationDashboardActions";

const initialState:IntegrationSchedule= {
    "fileName":"",
    "transformerId":"",
    "outProfileName":"",
    "passKey":"",
    "status":"Enabled",
    "env":"",
    "jobName":"",
    "skipCols":"0",
    "entityFileNameMapping":"",
    "entityName":"",
    "mapper":"",
    "profileName":"",
    "startsWith":"",
    "encoding":"UTF-8",
    "mapperName":"",
    "skipPreProcess":"",
    "delimiter":",",
    "lob":"",
    "headers":"",
    "frequency":"",
    "streamType":"",
}

export function IntegrationDashboardReducer(
    state:IntegrationSchedule=initialState,
    action:Action<any>) {

    switch(action.type){
        case INTEGRATION_ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        case INTEGRATION_ACTION_TYPES.SET_GENERIC :
            return {
                ...state,
                ...action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_LOB:
            return {
                ...state,
                lob: action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_MAPPER_NAME:
            return {
                ...state,
                mapperName: action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_INTEGRATION_SCHEDULE :
            return { 
                ...state, 
                ...action.payload 
            };
        case INTEGRATION_ACTION_TYPES.SET_PROFILE_NAME :
            return {
                ...state,
                profileName : action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_FILE_FILTER_PAGE_INFO :
            return {
                ...state,
                ...action.payload
            }
        case INTEGRATION_ACTION_TYPES.SET_TRANSFORMER_ID :
            return {
                ...state,
                transformerId : action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_MAPPER :
            return {
                ...state,
                mapper : action.payload.mapper,
                mapperName : action.payload.mapperName  
            };
        case INTEGRATION_ACTION_TYPES.SET_OUT_PROFILE_NAME :
            return {
                ...state,
                outProfileName : action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_ENTITY_FILE_MAPPING :
            return {
                ...state,
                entityFileNameMapping : action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_EXTRA_PARAMS :
            return {
                ...state,
                ...action.payload
            };
        case INTEGRATION_ACTION_TYPES.SET_HEADERS :
            return {
                ...state,
                headers : action.payload
            };
    }
    return state;
}